import { SVGProps } from 'react'

interface TileIconProps extends SVGProps<SVGSVGElement> {
  color?: string;
  secondaryColor?: string;
  fontSize?: string | number;
}

export function TileIcon({
  color = 'var(--primary-color)',
  secondaryColor = '#E1E1E1',
  fontSize = '24',
  style = {},
  onClick,
  ...props
}: TileIconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={fontSize}
      height={fontSize}
      viewBox='0 0 24 23'
      fill='none'
      style={style}
      onClick={onClick}
    >
      <rect y='0.0195312' width='10.2857' height='10.2857' rx='2' fill={secondaryColor} />
      <rect x='12.2856' y='0.0195312' width='10.2857' height='10.2857' rx='2' fill={color} />
      <rect y='12.3047' width='10.2857' height='10.2857' rx='2' fill={color} />
      <rect x='12.2856' y='12.3047' width='10.2857' height='10.2857' rx='2' fill={color} />
    </svg>
  )
}
